import type React from "react"
import { Button } from "@/components/ui/button"
import { ChatUnreadBadge } from "../../components/chat/chat-unread-badge"
import { getTranslations } from "../i18n"
import { useLocale } from "../locale-context"

interface Props {
	open: boolean
	unread: number
	onClick: () => void
	/** Context-specific label (e.g. "Property chat" / "Project chat"). */
	label?: string
}

const ChatIcon: React.FC<{ className?: string }> = ({ className }) => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.75"
		strokeLinecap="round"
		strokeLinejoin="round"
		className={className}
		aria-hidden="true"
	>
		<path d="M21 11.5a8.38 8.38 0 0 1-8.5 8.5 8.5 8.5 0 0 1-3.8-.9L3 21l1.9-5.7a8.5 8.5 0 0 1-.9-3.8 8.38 8.38 0 0 1 8.5-8.5A8.38 8.38 0 0 1 21 11.5Z" />
	</svg>
)

export function ChatRailToggleButton({ open, unread, onClick, label }: Props) {
	const { locale } = useLocale()
	const t = getTranslations(locale).chat.shared
	const text = label ?? t.headerName
	return (
		<Button
			variant="ghost"
			size="sm"
			onClick={onClick}
			aria-pressed={open}
			aria-label={text}
			className="relative"
		>
			<ChatIcon className="md:hidden" />
			<span className="hidden md:inline">{text}</span>
			<span className="absolute -top-1 -right-1">
				<ChatUnreadBadge count={unread} />
			</span>
		</Button>
	)
}
